import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const FILTERS_BASE_PATH = `${MIDDLE_OFFICE_BASE_PATH}/filters`;
